<template>
  <div class="schedule-tracker-row">
    <div class="schedule-tracker-left">
      <div :class="['schedule-tracker-top-line', isPrevItemCompleted ? 'schedule-tracker-line-completed' : '']" v-if="index > 0"></div>
      <div :class="['schedule-tracker-bottom-line', isItemCompleted ? 'schedule-tracker-line-completed' : '']" v-if="!isLastItem"></div>
      <div :class="['schedule-tracker-number', isItemCompleted ? 'bg-completed' : '', isItemCurrent ? 'bg-current' : '', isItemCancelled ? 'bg-cancelled' : '']">
        <i class="far fa-check" v-if="isItemCompleted"></i>
        <i class="far fa-times" v-if="isItemCancelled"></i>
        <span v-if="!isItemCompleted && !isItemCancelled">{{index+1}}</span>
      </div>
    </div>
    <div class="schedule-tracker-spacer"></div>
    <div class="schedule-tracker-content">
      <slot />
    </div>
  </div>
</template>

<style scoped lang="scss">
.schedule-tracker-row {
  width: 100%;
  display: flex;
  align-items: stretch;
}
.schedule-tracker-left {
  width: 15px;
  position: relative;
}
.schedule-tracker-bottom-line {
  border-right: 4px dotted #C0C0C0;
  position: absolute;
  top: 50%;
  bottom: 4px;  /* Offset dotted line */
  left: 0;
  right: 0;
}
.schedule-tracker-top-line {
  border-right: 4px dotted #C0C0C0;
  position: absolute;
  top: 0;
  bottom: 50%;
  left: 0;
  right: 0;
}
.schedule-tracker-line-completed {
  border-color: $label-status-completed;
}
.schedule-tracker-number {
  position: absolute;
  top: calc(50% - 16px);
  left: -2px;
  width: 30px;
  height: 30px;
  line-height: 30px;
  border-radius: 50%;
  vertical-align: middle;
  text-align: center;
  font-size: 16px;
  background-color: #B0B0B0;
  color: #ffffff;
}
.schedule-tracker-number.bg-completed {
  background-color: $label-status-completed;
}
.schedule-tracker-number.bg-current {
  background-color: $label-status-pending;
}
.schedule-tracker-number.bg-cancelled {
  background-color: $label-status-cancelled;
}
.schedule-tracker-spacer {
  width: 25px;
}
.schedule-tracker-content {
  flex: 1;
  margin-bottom: 2rem;
}

</style>


<script>
export default {
  name: 'ScheduleTrackerItem',
  props: {
    current: Boolean,
    completed: Boolean,
    cancelled: Boolean,
    index: Number
  },
  inject: {
    scheduleTracker: {
      default() {
        return { }
      }
    }
  },
  computed: {
    isPrevItemCompleted() {
      if(this.scheduleTracker)
        return this.scheduleTracker.isPrevItemCompleted(this)
      return false
    },
    isItemCompleted() {
      return this.completed
    },
    isItemCurrent() {
      return this.current
    },
    isItemCancelled() {
      return this.cancelled
    },
    isLastItem() {
      if(this.scheduleTracker)
        return this.scheduleTracker.isLastItem(this)
      return false
    }
  },
  mounted() {
    this.registerTrackerItem()
  },
  destroyed() {
    this.unregisterTrackerItem()
  },
  methods: {
    registerTrackerItem() {
      this.scheduleTracker.registerTrackerItem && this.scheduleTracker.registerTrackerItem(this)
    },
    unregisterTrackerItem() {
      this.scheduleTracker.unregisterTrackerItem && this.scheduleTracker.unregisterTrackerItem(this)
    },
  }
}
</script>